import Swiper from "swiper";
import pagination from "swiper/modules/pagination.min.mjs";
import autoplay from "swiper/modules/autoplay.min.mjs";
import Player from '@vimeo/player';
import barba from "@barba/core";

import scroll from "./animations/scroll/locomotiveScroll";
import { inViewport } from "./utils";

import sound from "./sound"

import { isMobile } from "./detector";

import "swiper/swiper.scss";
import "swiper/modules/pagination.scss";

class Carousel {
  constructor() {
    //
  }
  init () {
    const that = this
    this.swiper = new Swiper(".swiper", {
      modules: [pagination, autoplay],
      loop: true,
      autoplay: {
        delay: 3000,
      },
      pagination: {
        enabled: true,
        clickable: true,
        el: ".swiper-pagination",
        renderBullet: function (index, className) {
          return '<span class="' + className + '"></span>';
        },
      },
    });
    barba.hooks.beforeEnter((data) => {
      if (data.next.namespace === 'explore' || data.next.namespace === 'archive-wellness') {
        that.swiper.autoplay.play()
      } else {
        that.swiper.autoplay.stop()
      }
    })
  }

  embedVideo () {
    scroll.update()
    const that = this
    let activeIndex = 1
    let currentVideo
    let resume = false
    const carouselContainer = document.querySelector('.x-plore__slider')
    this.swiper.on('slideChange', (e) => {
      activeIndex = that.swiper.activeIndex + 1
      manageVideo(activeIndex)
    })

    const unsetVideo = (videoContainer, playerVimeo) => {
      videoContainer.style.display = 'none'
      playerVimeo.unload()
    }

    const playVideo = (videoContainer, playerVimeo) => {
      videoContainer.style.display = 'block'
      playerVimeo.play()
    }

    this.swiper.on('slideChangeTransitionEnd', (e) => {
      const previousIndex = that.swiper.previousIndex + 1
      const previousVideoEmbed = document.querySelector(`.vimeo-video-${previousIndex}`)
      const player = new Player(previousVideoEmbed.querySelector("iframe"))
      unsetVideo(previousVideoEmbed, player)
    })

    const manageVideo = (index) => {
      const watchBtn = document.querySelector(`.button-slide-${index}`)
      const videoEmbed = document.querySelector(`.vimeo-video-${index}`)
      currentVideo = videoEmbed
      const player = new Player(videoEmbed.querySelector("iframe"))
      that.player = player
      watchBtn.addEventListener('click', (e) => {
        that.swiper.autoplay.stop()
        if (isMobile.Android()) {
          player.requestFullscreen()
          player.setVolume(1)
        }
        if (sound && !sound.muted) {
          sound.mute()
        }
        playVideo(videoEmbed, player)
      })

      player.on('fullscreenchange', (event) => {
        if (!event.fullscreen) {
          unsetVideo(videoEmbed, player)
        }
      })

      document.addEventListener("visibilitychange", (event) => {
        if (document.visibilityState === "hidden") {
          player.pause()
          resume = true
        }
        if (document.visibilityState === "visible" && resume && videoEmbed.style.display !== 'none' && inViewport(carouselContainer)) {
          player.play()
          resume = false
        }
      });

      window.addEventListener('blur', () => {
        player.pause()
        resume = true
      })

      window.addEventListener('focus', () => {
        if (resume && videoEmbed.style.display !== 'none' && inViewport(carouselContainer)) {
          player.play()
          resume = false
        }
      })

      scroll.locoScroll.on("scroll", (event) => {
        if (!inViewport(carouselContainer)) {
          player.pause()
        } else if (inViewport(carouselContainer) && videoEmbed.style.display !== 'none') {
          player.play()
        }
      });
    }
    manageVideo(activeIndex)
  }
}

export default new Carousel()

// const swiper = new Swiper(".swiper", {
//   modules: [pagination],
//   loop: true,
//   autoplay: {
//     disableOnInteraction: true,
//   },
//   pagination: {
//     enabled: true,
//     clickable: true,
//     el: ".swiper-pagination",
//     renderBullet: function (index, className) {
//       return '<span class="' + className + '"></span>';
//     },
//   },
// });
